import FacturesManager from '@features/achats/components/factures/FacturesManager'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'
import { createFileRoute } from '@tanstack/react-router'
import { Receipt } from 'lucide-react'

export const Route = createFileRoute('/_app/achats/factures/')({
  staticData: {
    title: 'Factures',
    icon: Receipt,
    tab_icon: Receipt,
    permission: PERMISSIONS.ACHATS.FACTURES.VIEW,
    module: 'achats',
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: FacturesManager,
})
